import { render, staticRenderFns } from "./bgStaging.vue?vue&type=template&id=6b6e77b2&scoped=true&"
import script from "./bgStaging.vue?vue&type=script&lang=js&"
export * from "./bgStaging.vue?vue&type=script&lang=js&"
import style0 from "./bgStaging.vue?vue&type=style&index=0&id=6b6e77b2&prod&scoped=true&lang=css&"
import style1 from "./bgStaging.vue?vue&type=style&index=1&id=6b6e77b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6e77b2",
  null
  
)

export default component.exports